import React from "react";
import { Link, navigate } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import SciplayGames from "../sciplay-games";
import { isDesktop } from "react-device-detect";
import Arrow from "../../images/arrow";
import { useLocation } from "@reach/router";

const NavItems = ({
  openMobileMenu,
  onOpenMenuClick,
}: {
  openMobileMenu?: any;
  onOpenMenuClick?: any;
}) => {
  const { pathname } = useLocation();
  return (
    <>
      <div
        className={`menu-item menu-open-item${
          openMobileMenu === "slotsGames" ? " mobile-open" : " mobile-close"
        }`}
        onClick={() => onOpenMenuClick?.("slotsGames")}
      >
        <div
          className="flex justify-between items-center"
          onClick={() => isDesktop && navigate("/slot-games")}
        >
          <div className="xl:mb-0 open-menu-title">SLOTS GAMES</div>
          <div
            className={`menu-arrow flex justify-center${
              openMobileMenu === "slotsGames" ? " arrow-up" : " arrow-down"
            }`}
          >
            <Arrow />
          </div>
        </div>
        <div className="open-menu">
          <div className="flex w-full xl:w-2/3 flex-col mb-10 xl:mb-0">
            <div className="text-white text-3xl uppercase mb-5 hidden xl:block">
              <Link to="/slot-games/">Free Slots</Link>
            </div>
            <div className="flex flex-col xl:grid xl:grid-cols-2 xl:gap-y-3">
              <div className="block xl:hidden">
                <Link to="/slot-games/">Free Slots</Link>
              </div>
              <div>
                <Link to="/slot-games/bonus-rounds/">
                  Free Slots With Bonus
                </Link>
              </div>
              <div>
                <Link to="/slot-games/trending-slots/">Trending Slots</Link>
              </div>
              <div>
                <Link to="/slot-games/classic-slots/">Classic Slots</Link>
              </div>
              <div>
                <Link to="/slot-games/video-slots/">Video Slots</Link>
              </div>
              <div>
                <Link to="/slot-games/progressive-jackpots/">
                  Progressive Slots
                </Link>
              </div>
              <div>
                <Link to="/slot-games/vegas-slots/">Vegas Slots</Link>
              </div>
              <div>
                <Link to="/slot-games/bally-slots/">Bally Slots</Link>
              </div>
              <div>
                <Link to="/slot-games/wms-slots/">WMS Slots</Link>
              </div>
            </div>
          </div>
          <div className="flex flex-col w-full xl:w-3/4">
            <div className="text-white hidden xl:block xl:text-3xl uppercase mb-5">
              <Link to="/slot-games/featured-slots/">Featured Slots</Link>
            </div>
            <div className="flex open-menu-slots-icons">
              <Link to="/slot-games/zeus-ii/">
                <StaticImage
                  src="../../images/slots/ZeusII.png"
                  alt=""
                  width={120}
                />
              </Link>
              <Link to="/slot-games/huff-n-more-puff/">
                <StaticImage
                  src="../../images/slots/Huff-N-More.webp"
                  alt=""
                  width={120}
                />
              </Link>
              <Link to="/slot-games/rich-little-piggies-hog-wild/">
                <StaticImage
                  src="../../images/slots/Rich-Little-Piggies-Meal-Ticket-and-Hog-Wild.webp"
                  alt=""
                  width={120}
                />
              </Link>
              <Link to="/slot-games/invaders-from-the-planet-moolah/">
                <StaticImage
                  src="../../images/slots/InvadersFromThePlanetMoolah.png"
                  alt=""
                  width={120}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-8 hidden xl:block menu-divine">|</div>
      {/* <Link className='menu-item' to='/promotions'>
        PROMOTIONS
      </Link>
      <div className='pb-8 hidden xl:block'>|</div> */}
      <Link className="menu-item" to="/free-coins/">
        FREE COINS
      </Link>
      <div className="pb-8 hidden xl:block menu-divine">|</div>
      <a
        className="menu-item"
        href="https://jackpotpartycasino.zendesk.com/hc/en-us"
        target="_blank"
      >
        HELP
      </a>
      <div className="pb-8 hidden xl:block menu-divine">|</div>
      {!pathname.includes("/blog") && (
        <>
          <Link className="menu-item" to="/blog/">
            BLOG
          </Link>
          <div className="pb-8 hidden xl:block menu-divine">|</div>
        </>
      )}
      <div
        className={`menu-item menu-open-item${
          openMobileMenu === "sciplayApps" ? " mobile-open" : " mobile-close"
        }`}
        onClick={() => onOpenMenuClick?.("sciplayApps")}
      >
        <div
          className="flex justify-between items-center mb-5 xl:mb-0"
          onClick={() =>
            isDesktop && window.open("https://www.sciplay.com/#games", "_blank")
          }
        >
          <div className="mr-2 xl:mb-0 open-menu-title">SCIPLAY APPS</div>
          <div className="menu-arrow flex justify-center">
            <Arrow />
          </div>
        </div>
        <div className="open-menu">
          <div className="logos w-full">
            <div className="text-white text-3xl uppercase mb-5 hidden xl:block">
              SciPlay Apps
            </div>
            <SciplayGames showTitles={true} />
          </div>
        </div>
      </div>
    </>
  );
};

export default NavItems;
